import SdsIcon from "@salesforce-ux/sds-components/src/icon/icon";
import css from "./icon.css";

export default class FooIcon extends SdsIcon {
  connectedCallback() {
    super.connectedCallback();
    this.shadowRoot.innerHTML += `<style>${css}</style>`;
  }
}
